import { Component, ElementRef, ViewChild } from '@angular/core';
import { cloneDeep } from 'lodash';
import { ConfirmEventType, ConfirmationService, Message, MessageService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DataView } from 'primeng/dataview';
import { ProfileImageService } from 'src/app/services/profile-image.service';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf';
import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['../../admin/views/data/content-update-page/content-update-page.component.scss', './user-profile.component.scss'],
  providers: [MessageService]
})
export class UserProfileComponent {
  fileInput!: HTMLInputElement;
  messages: Message[] = [];

  @ViewChild('dv')
  dataView!: DataView;


  @ViewChild('certificateElement') certificateElement?: ElementRef
  loadingCert: boolean = true;


  fileUrl = GlobalConstants.staticFilesURL;

  progressModal = false
  trainingModal = false;
  openUserUpdateModal: boolean = false;
  editData: any;
  viewDetails: boolean = false;
  translator: TranslatorPipe = new TranslatorPipe()

  // fileUrl = GlobalConstants.staticFilesURL;


  staticURL = GlobalConstants.staticFilesURL;


  courseDetailsUserProfile: any;
  data: any
  filteredData: any

  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;
  currentTypeFilter: any = 'all';
  image: string | null = null;

  first: number = 0;
  rows: number = 10;
  sortOrder: number = 1;
  sortField: string = '';

  currentComment: any

  //filter options
  treeData: any[] = [];

  parentOUS = [
    'الجهات المشاركة',
  ];

  surveys: any[] = [];
  attemptedSurveys: any[] = [];
  trainingSurveys: any[] = [];
  currentTab: string = 'Pending';
  filteredSurveys: any[] = [];

  assessments: any[] = [];
  attemptedAssessments: any[] = [];
  trainingAssessments: any[] = [];
  assessmentsTab: string = 'Pending';
  filteredAssessments: any[] = [];
  
  questionsToShow: any[] = [];
  scoreHideQuestions: string[] = ['PRESENTATION_TEXT','SECTION_HEADING','SECTION_SUB_HEADING'];
  openEndedQuestions: string[] = ["SINGLE_ROW_TEXT","EMAIL_ADDRESS","COMMENT_BOX","CONTACT_INFO","DRAG_DROP"];

  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;
  cardData: any;
  currentDate: Date = new Date();
  allData!: any[];
  filtered: any = [];
  pending!: boolean;
  complete!: boolean;
  ongoing!: boolean;
  attendanceShort!: boolean;
  assessmentTraining = true
  skilledCourses: any
  trainingType: any
  selectedTraining: any
  tabs: any[] = [];
  rangeDates: Date | undefined;
  uid: any;
  openQuestionModal: boolean = false
  showResult: any;
  ous: any[] = [];
  trainingViewOptions: any[] = [
    { name: this.translate('Calender View'), value: 'Calender View' },
    { name: this.translate('List View'), value: 'List View' },
  ];

  trainingView: string = 'List View'

  /**
   * Whether this person delivers training, from the flags KGate writes at
   * sign-in. A trainer is a flag on the user, not a permission unit — see
   * Tayseer's `AuthService.isTrainer` and ADR-0006 — so this reads the same
   * three keys it does, and the same way: `branchTrainer` is stored as JSON
   * while the other two are plain strings.
   *
   * This profile is always the signed-in user's own (`uid` comes from
   * localStorage), so there is no viewer-versus-subject question to settle.
   */
  isTrainer: boolean = false;

  constructor(
    private fileService: ImageuploadService,
    private dataService: DataService,
    private orgUnits: OrgUnitsService,
    private confirmationService: ConfirmationService,
    private permissionService: PermissionHandlerService,
    private profileService: ProfileImageService,
    private router: Router,
    private messageService: MessageService
  ) { }


  ngOnInit() {
    this.currentStatus = this.statusOptions[0].name
    this.getTreeData().then(e => { this.getComments() });
    this.getTrainingAssessmentsSurveys().then(() => {
      this.getUnattemptedSurveys();
      this.getAttemptedSurveys();
      this.getUnattemptedAssessments();
      this.getAttemptedAssessments();
    });
    this.extractImage();
    this.getProgress();
    this.uid = localStorage.getItem('uid');
    this.ous = JSON.parse(localStorage.getItem('ou') ?? '[]');
    this.isTrainer = this.readTrainerFlags();
    this.getUserData()
    this.userCourse().then(() => {
      this.countStatus()
      this.filterByStatus('ONGOING')
    });
    this.getTrainingTypes().then(() => {
      this.getUserSuggestedCurses();
    })
  }

  async getUserData() {
    try {
      // The backend has no GET /user/:id route. Use the existing
      // POST /user/get endpoint with an _id filter (same pattern as
      // create-course.component.ts) and pick the first match.
      const res = await this.dataService.postData('user/get', { _id: this.uid });
      if (res?.error) {
        return;
      }

      if (Array.isArray(res?.data) && res.data.length > 0) {
        this.editData = res.data[0];
      }
    } catch (e) {
      console.warn('Failed to load user data for edit modal', e);
    }
  }

  user: any
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });

    if (res.error) {
      return;
    }
    this.trainingType = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        allowed_ou: item.allowed_ou,
        name: this.translate(item.name),
        arabic: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item.name,
      };
    });
    this.tabs = this.trainingType

    this.tabs.unshift({
      arabic: this.translate('ALL'),
      value: 'clear',
    })

  }

  handleUpdatedUserData(data: any) {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  extractImage() {


    let img = localStorage.getItem('image');
    let national_id = localStorage.getItem('national_id');
    let phone = localStorage.getItem('phone');
    let gender = localStorage.getItem('gender');
    let username = localStorage.getItem('username');
    let email = localStorage.getItem('email');

    this.user = {
      email: email,
      national_id: national_id,
      phone: phone,
      gender: gender,
      username: username
    }

    if (img) {
      
      if(img == "undefined") {
        if(gender == "أنثى") {
          this.image = "https://kgate.bc.gov.sa/json/public/profile/profile_female.png"
        } else {
          this.image = "https://kgate.bc.gov.sa/json/public/profile/profile_male.png"
        }
        
      } else {
        this.image = GlobalConstants.staticFilesURL + img;
      }
      
    }

  }

  // launchUrl(id: string) {
  //   window.open('/survey/attempt/' + id, '_blank')
  // }

  // getUserData(){
  //   try {
  async userCourse() {
    try {
      let res = await this.dataService.getData('course/user/' + this.uid);
      if (res.error) return;
      // this.cardData = res.data;
      this.allData = cloneDeep(this.onlyPublishedContinuousTrainings(res.data));
      // this.filterByStatus('ONGOING')
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Continuous trainings are listed only while their course is Published.
   *
   * A Draft course is still being authored in Tayseer and an Archived one has
   * been withdrawn; the enrollment outlives both, because the record is kept for
   * history. Showing either put a card on the profile that opened a course the
   * catalog no longer offers.
   *
   * Only cs2 cards are judged: a legacy KGate course and an onboarding
   * programme carry no `courseStatus`, and the onboarding query already takes
   * `published: true`.
   *
   * A card that states no status at all is kept rather than dropped. The API
   * applies this same rule before answering, so this is the second of two
   * gates; if it ever stops sending the field, the failure to prefer is showing
   * the cards, not emptying every profile.
   */
  private onlyPublishedContinuousTrainings(courses: any): any[] {
    if (!Array.isArray(courses)) return [];
    return courses.filter(
      (course: any) =>
        !course?.isCs2 || !course?.courseStatus || course.courseStatus === 'Published'
    );
  }

  //    getStartEndOfMonth(inputDate : Date) {
  //     let date = new Date(inputDate);

  //     date.setDate(1);
  //     let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //     let startDate = date.toISOString().split('T')[0];
  //     let endDate = lastDay.toISOString().split('T')[0];
  //     return {
  //         startDate,
  //         endDate
  //     };
  // }

  getStartEndOfMonth(inputDate: any) {
    let date = new Date(inputDate);
    date.setDate(1);

    // Get the last day of the month
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    // Format dates as 'YYYY-MM-DD'
    let startDate = this.formatDate(date);
    let endDate = this.formatDate(lastDay);

    return {
      startDate,
      endDate
    };
  }

  formatDate(date: any) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    // Ensure two-digit formatting
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return `${year}-${month}-${day}`;
  }


  async getUserSuggestedCurses() {
    try {
      let date;
      if (this.rangeDates) date = this.getStartEndOfMonth(this.rangeDates);
      else date = this.getStartEndOfMonth(new Date());
      date
      let data = {
        id: this.uid,
        start_date: date.startDate,
        end_date: date.endDate
      }
      this.rangeDates
      let res = await this.dataService.postData('user/skill-trainings/', data);
      if (res.error) return;
      this.skilledCourses = res.data;
    } catch (error) {
      console.log(error);
    }
  }



  assAttendeesInitiate(data: any) {
    this.confirm({
      message: this.translate('Are you sure you waant to register in this course?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-check-square',
      action: () => this.assAttendees(data),
    });
  }

  assigningCourse = false
  async assAttendees(data: any) {
    try {

      let message = 'User Added to training'

      let requestData: any = {
        _id: data._id,
        attendees: [localStorage.getItem('uid')]
      }

      if (data.registrationType == 'Self Register Manager Approval') {
        requestData.flag = 'User Request',
          message = 'Your request for the course is send to the manager'
      }

      let res = await this.dataService.postData('course/assign-attendees', requestData, 'PUT', false);
      if (res.msg == "Users added to pending list") {
        this.messageService.add({ severity: 'success', summary: this.translate('success'), detail: this.translate('Users added to waiting list') });

      } else {
        this.messageService.add({ severity: 'success', summary: this.translate('success'), detail: this.translate(message) });
      }

      // 'message'
      if (!res.error) {
        window.location.reload()
        return
      }
    } catch (error) {
      console.log(error)
    }

  }

  statusByDate(startDate: string, endDate: string) {

    if (new Date(startDate) <= this.currentDate && new Date(endDate) >= this.currentDate) return 'مستمرة';

    else if (new Date(endDate) < this.currentDate) return 'المكتملة';

    else if (new Date(startDate) > this.currentDate) return 'قيد الانتظار';

    return '';

  }

  launchUrl(id: string, type: string, courseId: string = '') {
    let email = localStorage.getItem('email');
    let url = '';
    if (courseId != '') {
      url = "?courseId=" + courseId;
    }
    if (type == "survey") {
      window.open('/sa/survey/attempt/' + id + url, '_blank');
    }
    else if (type == "assessment") {
      if (this.assessmentsTab == 'Attempted') {
        window.open('/assessment/certificate/' + id + '/' + email + '?from=profile', '_blank');
      }
      else {

        window.open('/sa/assessment/attempt/' + id + url, '_blank');
      }
    }
  }

  // Opens an attempted survey's result page in a new tab.
  viewSurveyResult(surveyId: string) {
    if (!surveyId) {
      return;
    }
    window.open('/survey/results/' + surveyId, '_blank');
  }

  // Opens the user edit modal. If user data hasn't loaded yet (e.g. the
  // initial getUserData call is still in flight or failed), attempt one more
  // fetch so the embedded edit form always has data to render against.
  async openEditUserModal() {
    if (!this.editData) {
      await this.getUserData();
    }
    this.openUserUpdateModal = true;
  }


  trainingStatusCount: any

  async filterByStatus(status: string) {
    this.cardData = cloneDeep(this.allData)

    if (this.selectedTraining && this.selectedTraining.value == 'clear') {
      this.selectedTraining = null
      this.countStatus()
    }

    if (status == 'null') status = 'ONGOING'
    if (this.selectedTraining) {
      this.cardData = this.cardData.filter((item: any) => item.type.name == this.selectedTraining?.value)
      this.countStatus()
    }

    this.complete = false;
    this.pending = false;


    // let  status =  obj.value.join(',');
    this.filtered = [];

    if (status == 'ONGOING') {
      this.cardData.forEach((item: any) => {
        if (!item.certifiedUsers.includes(this.uid) && new Date(item.start_date).setHours(0, 0, 0, 0) <= this.currentDate.setHours(0, 0, 0, 0) && new Date(item.end_date).setHours(0, 0, 0, 0) >= this.currentDate.setHours(0, 0, 0, 0)) {
          this.filtered.push(item);

          // this.cardData.splice(this.cardData.indexOf(item._id), 1);
        }
      });
      this.cardData = this.filtered;
      this.ongoing = true;
      this.complete = false;
      this.pending = false;
      this.attendanceShort = false
      console.log("Total attendace -", this.cardData)

    }
    else if (status == 'COMPLETE') {
      this.cardData


      this.cardData.forEach((item: any) => {
        if (item.certifiedUsers.includes(this.uid)) {
          this.filtered.push(item);
        }
        else if (new Date(item.end_date) < this.currentDate) {

          let allsessions = item.session.filter((e: any) => !e.sessionId?.video_url)

          console.log("Total attendace -", this.calculateAttendancePercentage(allsessions))
          // this.calculateAttendancePercentage(allsessions)

          let attendancePercentage = this.calculateAttendancePercentage(allsessions);
          if (isNaN(attendancePercentage) || attendancePercentage >= 70 || allsessions.length <= 0) {

            this.filtered.push(item);
            // this.cardData.splice(this.cardData.indexOf(item._id), 1);           
          }

        }



      });
      this.cardData = this.filtered;
      this.complete = true;
      this.pending = false;
      this.ongoing = false;
      this.attendanceShort = false

    }
    else if (status == 'ATTENDANCE_SHORT') {
      this.cardData.forEach((item: any) => {
        if (new Date(item.end_date) < this.currentDate) {
          let allsessions = item.session.filter((e: any) => !e.sessionId?.video_url)
          let value = this.calculateAttendancePercentage(allsessions)

          if (this.calculateAttendancePercentage(allsessions) < 70) {
            this.filtered.push(item);
            // this.cardData.splice(this.cardData.indexOf(item._id), 1);
          }
        }
      });
      this.cardData = this.filtered;
      this.complete = false;
      this.pending = false;
      this.ongoing = false;
      this.attendanceShort = true

    } else {
      this.cardData.forEach((item: any) => {
        if (new Date(item.start_date) > this.currentDate) {
          this.filtered.push(item);
          // this.cardData.splice(this.cardData.indexOf(item._id), 1);
        }
      });
      this.cardData = this.filtered;
      this.complete = false;
      this.ongoing = false;
      this.pending = true;
      this.attendanceShort = false
      console.log("Total attendace -", status, this.cardData)
    }

  }

  countStatus() {

    let allData = cloneDeep(this.allData)

    if (this.selectedTraining) {
      allData = this.cardData.filter((item: any) => item.type.name == this.selectedTraining?.value)
    }

    let ongoing = 0
    let completed = 0
    let attendanceShort = 0
    let upcoming = 0
    let total = 0


    // ongoing
    allData.forEach((item: any) => {
      if (!item.certifiedUsers.includes(this.uid) && new Date(item.start_date).setHours(0, 0, 0, 0) <= this.currentDate.setHours(0, 0, 0, 0) && new Date(item.end_date).setHours(0, 0, 0, 0) >= this.currentDate.setHours(0, 0, 0, 0)) {
        this.filtered.push(item);
        ongoing++
      }

      //completed
      else {
        if (item.certifiedUsers.includes(this.uid)) {
          total++
          completed++
        }
        else if (new Date(item.end_date).setHours(0, 0, 0, 0) < this.currentDate.setHours(0, 0, 0, 0)) {
          total++
          let allsessions = item.session.filter((e: any) => !e.sessionId?.video_url)
          let attendancePercentage = this.calculateAttendancePercentage(allsessions);
          if (isNaN(attendancePercentage) || attendancePercentage >= 70) {
            completed++
          } else {
            attendanceShort++
          }

        } else {
          upcoming++
        }
      }

    });



    this.trainingStatusCount = {
      ONGOING: ongoing,
      COMPLETE: completed,
      ATTENDANCE_SHORT: attendanceShort,
      UPCOMING: upcoming
    }

    total

  }




  calculateAttendancePercentage(sessions: any) {

    let uid = localStorage.getItem('uid');

    // Filter sessions where the attendee is present
    const attendedSessions = sessions.filter((session: any) => session?.attendees?.includes(uid));

    // Calculate total sessions and attended sessions count
    const totalSessions = sessions.length;
    const attendedSessionsCount = attendedSessions.length;

    // Calculate attendance percentage
    const attendancePercentage = (attendedSessionsCount / totalSessions) * 100;

    return attendancePercentage;
  }

  courseDetail(course: any) {

    this.courseDetailsUserProfile = course;
    this.courseDetailsUserProfile.userProfile = true;
    this.viewDetails = true;


  }

  async getTreeData() {
    this.treeData = await this.orgUnits.getOrgUnits();
  }

  async openCourse(id: any, course?: any) {
    try {
      // Course System 2 courses live in the Tayseer portal, which is served
      // same-origin under /training. KGate's own training page cannot resolve
      // them. A plain location change is required: an Angular route would be
      // handled by this app rather than reaching the /training proxy.
      if (course?.isCs2) {
        // Deep link rather than a bare /continuous: Tayseer reads these params
        // on load, so the catalog opens with this course's details already up
        // instead of dropping the user on the hub to find it again.
        const params = new URLSearchParams({ view: 'available', course: String(id) });
        window.location.href = `/training/continuous?${params}`;
        return;
      }

      // Onboarding programmes live in Tayseer too, but its onboarding module is
      // for the people who build programmes: an attendee holds none of its
      // permission units and would be turned away at the door. This is the
      // attendee's own read-only view of the programme, authorized by being on
      // it rather than by a unit, so the card works for everyone it is shown to.
      // Authors get a link into the builder once they are there.
      if (course?.isOnboarding) {
        window.location.href = `/training/onboarding/my/${id}`;
        return;
      }

      let params = {
        _id: id,
        // flag : 'VIEW', 
        from: 'User'
      }
      this.navigateToTrainingPage(params)
    } catch (error) {
      console.log(error);
    }


  }

  /** Any one of KGate's three trainer flags, however it was stored. */
  private readTrainerFlags(): boolean {
    return ['master_trainer', 'branchTrainer', 'strainer'].some((key) => {
      const raw = localStorage.getItem(key);
      if (!raw) return false;
      try {
        return JSON.parse(raw) === true;
      } catch {
        return raw === 'true';
      }
    });
  }

  /**
   * The trainer's own sessions, in Tayseer.
   *
   * A plain location change for the same reason `openCourse` uses one: Tayseer
   * is served same-origin under `/training`, and an Angular route would be
   * handled by this app instead of reaching it.
   *
   * It lands on Continuous Training's delivery view because that is where most
   * assignments are; a trainer whose sessions are onboarding track sessions is
   * offered the other module from there, since only Tayseer knows which of the
   * two they actually have.
   */
  openTrainerDelivery() {
    window.location.href = '/training/continuous?view=delivery';
  }

  navigateToTrainingPage(params: any) {
    const trainingId = params._id;
    this.router.navigate(['/training/training-page', trainingId], { queryParams: params });
  }

  pickImage() {
    this.fileInput = document.createElement('input');
    this.fileInput.type = 'file';
    this.fileInput.addEventListener('change', this.onFileSelected.bind(this));
    this.fileInput.style.display = 'none';
    document.body.appendChild(this.fileInput);
    this.fileInput.click();
  }

  isCurrentDateTimeGreaterThanEndDate(endDateString: string): boolean {
    const endDate = this.parseDate(endDateString);
    if (!endDate) {
      console.error('Invalid date format');
      return false;
    }
    const currentDate = new Date();
    return currentDate <= endDate;
  }

  private parseDate(dateString: string): Date | null {
    const hasTime = dateString.includes(' ');

    if (hasTime) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('-').map(Number);
      const [hours, minutes] = timePart.split(':').map(Number);
      if (isNaN(day) || isNaN(month) || isNaN(year) || isNaN(hours) || isNaN(minutes)) {
        return null;
      }

      return new Date(year, month - 1, day, hours, minutes);
    } else {
      const [day, month, year] = dateString.split('-').map(Number);
      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return null;
      }
      return new Date(year, month - 1, day);
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const res = await this.fileService.uploadImage(file, ImageTypes.profile);
      console.log(res);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
      } else {
        this.messages = [
          { severity: 'success', summary: this.translate('success'), detail: res.msg },
        ];
        this.profileService.setImage(res.data)
        localStorage.setItem('image', res.data);
        this.extractImage();
      }
      document.body.removeChild(this.fileInput);
    }
  }


  refresh() {
    this.typeFilter = undefined;
    this.oufilter = undefined;
    this.filteredData = this.data;
    this.currentStatus = this.statusOptions[0].name;
    this.changeCurrent(this.filteredData[0]);
    // this.handleStatusChange()
  }

  applyOUFilter(event: any) {
    console.log("EVENT", this.data, event._id);
    this.filteredData = this.data.filter((e: any) => e._id.ous == event._id);

    if (this.filteredData) {
      this.changeCurrent(this.filteredData[0]);
    } else {
      this.currentComment = null;
    }
  }

  changeCurrent(current: any) {
    this.currentComment = cloneDeep(current);
  }

  async getComments() {
    try {
      let res = await this.dataService.getData('comments/user/comments')
      console.log('RESOURCE', res);
      if (res.error) {
        return
      }
      this.data = res.data;
      console.log('RESOURCE', this.data);
      this.filteredData = this.data;
      if (this.filteredData.length > 0) {
        this.changeCurrent(this.filteredData[0])
      }
      this.totalRecords = this.data.length
      this.first = 0;
      this.rows = 10;
      // this.handleStatusChange();
      // this.applyOUPermission();
    } catch (error) {
      console.log(error)
    }
  }

  async getUnattemptedSurveys() {
    try {
      let email = localStorage.getItem('email');
      let res = await this.dataService.getData(`survey/unattempted/${email}`)
      console.log('RESOURCE = Survey', res);
      if (res.error) {
        return
      }
      this.surveys = res.data;
      this.surveys = this.surveys.filter((item: any) => item.matchedDocument.length == 0);
      if (this.trainingSurveys != undefined) {
        this.surveys = [...this.surveys, ...this.trainingSurveys]
      }
      this.changeSurveyTabs('Pending');
    } catch (error) {
      console.log(error)
    }
  }

  async getAttemptedSurveys() {
    try {
      let email = localStorage.getItem('email');
      let res = await this.dataService.getData(`survey/attempted/${email}`)
      console.log('RESOURCE = Survey', res);
      if (res.error) {
        return
      }
      this.attemptedSurveys = res.data;
    } catch (error) {
      console.log(error)
    }
  }

  async getTrainingAssessmentsSurveys() {
    try {
      let res = await this.dataService.postData(`course/get-assessment-survey`, '')
      console.log('RESOURCE', res);
      if (res.error) {
        return
      }
      this.trainingSurveys = res.data.surveysData;
      this.trainingAssessments = res.data.assessmentData;
    } catch (error) {
      console.log(error)
    }
  }

  async getUnattemptedAssessments() {
    try {
      let email = localStorage.getItem('email');
      let res = await this.dataService.getData(`assessment/unattempted/${email}`)
      console.log('RESOURCE', res);
      if (res.error) {
        return
      }
      this.assessments = res.data;
      this.assessments = this.assessments.filter((item: any) => item.matchedDocument.length == 0);
      if (this.trainingAssessments != undefined) {
        this.assessments = [...this.assessments, ...this.trainingAssessments]
      }
      this.changeAssessmentsTabs('Pending');
    } catch (error) {
      console.log(error)
    }
  }

  async getAttemptedAssessments() {
    try {
      let email = localStorage.getItem('email');
      let res = await this.dataService.getData(`assessment/attempted/${email}`)
      console.log('RESOURCE', res);
      if (res.error) {
        return
      }
      this.attemptedAssessments = res.data;
    } catch (error) {
      console.log(error)
    }
  }

  changeSurveyTabs(tab: string) {
    this.currentTab = tab;
    if (this.currentTab == 'Pending') {
      this.filteredSurveys = this.surveys;
    } else if (this.currentTab == 'Attempted') {
      this.filteredSurveys = this.attemptedSurveys;
    }
  }

  changeAssessmentsTabs(tab: string) {
    this.assessmentsTab = tab;
    if (this.assessmentsTab == 'Pending') {
      this.filteredAssessments = this.assessments;
    } else if (this.assessmentsTab == 'Attempted') {
      this.filteredAssessments = this.attemptedAssessments;
    }
  }

  isSurveyResult: boolean = false;

  resultTitle: string = '';
  resultFilter: 'all' | 'correct' | 'incorrect' = 'all';
  resultRows: any[] = [];
  resultSummary = { score: 0, total: 0, percentage: 0, correct: 0, incorrect: 0 };

  loadResults(result: any, isSurvey: boolean = false, title: string = '') {
    this.isSurveyResult = isSurvey;
    this.questionsToShow = result?.questions || [];
    this.showResult = result;
    this.resultTitle = title;
    this.resultFilter = 'all';
    this.buildResultRows();
    this.openQuestionModal = true;
  }

  buildResultRows() {
    const summary = { score: 0, total: 0, percentage: 0, correct: 0, incorrect: 0 };
    let questionNumber = 0;

    this.resultRows = this.questionsToShow
      .filter((question: any) => !this.scoreHideQuestions.includes(question?.type))
      .map((question: any, index: number) => {
        questionNumber++;
        const marks = Number(question?.meta?.marks) || 0;
        const score = Number(question?.score) || 0;
        const isCorrect = score > 0;

        if (!this.isSurveyResult) {
          summary.score += score;
          summary.total += marks;
          isCorrect ? summary.correct++ : summary.incorrect++;
        }

        const answer = this.formatAnswer(question, question?.meta?.value);
        return {
          question,
          number: questionNumber,
          title: this.stripHtml(question?.questionText || question?.meta?.description),
          score,
          marks,
          isCorrect,
          answer,
          // Complex types (ratings, scales, ordering) fall back to the read-only question template
          useTemplate: answer === null,
          correctAnswer: !isCorrect ? this.formatCorrectAnswer(question) : null,
          feedback: question?.meta?.feedback?.trim() || '',
          expanded: !this.isSurveyResult && !isCorrect,
        };
      });

    summary.percentage = summary.total ? Math.round((summary.score / summary.total) * 100) : 0;
    this.resultSummary = summary;
    if (this.resultRows.length && !this.resultRows.some((row) => row.expanded)) {
      this.resultRows[0].expanded = true;
    }
  }

  get filteredResultRows(): any[] {
    if (this.resultFilter === 'correct') {
      return this.resultRows.filter((row) => row.isCorrect);
    }
    if (this.resultFilter === 'incorrect') {
      return this.resultRows.filter((row) => !row.isCorrect);
    }
    return this.resultRows;
  }

  formatAnswer(question: any, value: any): string | null {
    const meta = question?.meta || {};
    switch (question?.type) {
      case 'SINGLE_ROW_TEXT':
      case 'EMAIL_ADDRESS':
      case 'COMMENT_BOX':
      case 'CONTACT_INFO':
        return (meta.fields || [])
          .filter((field: any) => field?.value !== undefined && field?.value !== null && `${field.value}`.trim() !== '')
          .map((field: any) => (meta.fields.length > 1 && field.label ? `${field.label}: ${field.value}` : field.value))
          .join('، ');
      case 'SELECT_ONE':
      case 'DROPDOWN_MENU':
      case 'SELECT_ONE_IMAGE':
      case 'SMILE_RATING':
        return value !== undefined && value !== null ? `${value}` : '';
      case 'SELECT_MANY':
      case 'SELECT_MANY_IMAGE':
        return Array.isArray(value) ? value.join('، ') : value ? `${value}` : '';
      case 'DATE_TIME':
        return value && (value.day || value.month || value.year)
          ? [value.day, value.month, value.year].filter(Boolean).join('/')
          : '';
      case 'IMPACT_MEASUREMENT':
        return meta.empAnswer || '';
      default:
        return null;
    }
  }

  formatCorrectAnswer(question: any): string {
    const correct = question?.meta?.correct;
    const correctValueTypes = ['SELECT_ONE', 'DROPDOWN_MENU', 'SELECT_ONE_IMAGE', 'SMILE_RATING', 'SELECT_MANY', 'SELECT_MANY_IMAGE', 'DATE_TIME'];
    if (!correctValueTypes.includes(question?.type) || correct === undefined || correct === null || correct === '') {
      return '';
    }
    const formatted = this.formatAnswer(question, correct);
    return formatted ?? '';
  }

  // Question text can come from the rich-text editor, so render it as plain text
  stripHtml(html: string): string {
    if (!html) {
      return '';
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || '').trim();
  }

  toggleResultRow(row: any) {
    row.expanded = !row.expanded;
  }

  progressArray: any = []

  totalProgressPercentage: number = 0

  progressDetails: any


  async getProgress() {
    try {

      let uid = localStorage.getItem('uid');

      let res = await this.dataService.getData('states/progress/' + uid);
      if (res.error) {
        return
      }

      this.totalProgressPercentage = Math.floor((res.data.progress.length / res.data.totalDataCount) * 100);

      // Create an object to store counts
      const counts: any = {};
      const obj: any = {}

      // Use reduce to count occurrences of each ou.id
      res.data.progress.forEach((item: any) => {
        const ouId = item.ou.id;
        obj[ouId] = item.ou
        counts[ouId] = (counts[ouId] || 0) + 1;
      });

      // Create an array of unique objects with counts
      const uniqueObjects = Object.keys(counts).map((ouId) => ({
        ouId: parseInt(ouId), // Convert ouId to a number if needed
        count: counts[ouId],
        obj: obj[ouId],
        total: obj[ouId].data_counter.reduce((partialSum: any, a: any) => partialSum + a.count, 0),
        percent: Math.floor((counts[ouId] / obj[ouId].data_counter.reduce((partialSum: any, a: any) => partialSum + a.count, 0)) * 100)
      }));

      this.progressDetails = uniqueObjects
      console.log("unque", uniqueObjects);

      // this.applyOUPermission();
    } catch (error) {
      console.log(error)
    }
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }

  goToPage(maxPage: number) {
    // Validate input and navigate to the specified page

    console.log(maxPage, this.currentPage, this.currentPage >= 1 && this.currentPage <= maxPage);
    if (this.currentPage >= 1 && this.currentPage <= maxPage) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows
      });
    }
  }
  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.first = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ first: this.first, rows: this.rows })
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.first = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        first: this.first,
        rows: this.rows
      });
    }
  }

  changePage(n: number) {
    const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
    if (n > 0 && n <= maxPage) {
      console.log(n, this.currentPage, maxPage);
      this.currentPage = n;
      this.goToPage(n);
    }
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dataView.filter($event.target.value, stringVal);
  }

  handleStatusChange() {
    let current = this.data.find((e: any) => e._id._id == this.currentComment._id._id);
    if (current) {
      this.currentComment.comments = current.comments.filter((e: any) => e.status == this.currentStatus);
    }
    console.log("STATUS", this.currentStatus);
  }



  statusOptions = [
    { name: 'PENDING', value: 1, arabic: this.translate('PENDING') },
    { name: 'APPROVED', value: 2, arabic: this.translate('acceptable') },
    { name: 'REJECTED', value: 3, arabic: this.translate('REJECTED') }
  ];

  currentStatus: any;

  changeView(_t29: any) {
    this.changeCurrent(_t29);
    // this.handleStatusChange();
  }


  certificateData: any

  printCertificate(event: Event, course: any) {
    event.stopPropagation(); // Stop event propagation
    this.loadingCert = true;
    try {
      this.certificateData = {
        _id: course._id,
        courseStartDate: course.start_date,
        courseEndDate: course.end_date,
        courseName: course.title,
        courseType: course.type.arabic,
        awardedTo: this.user.username,
      }


      setTimeout(() => {
        let element = this.certificateElement?.nativeElement;
        console.log(element)
        if (element) {
          html2canvas(element, {
            onclone: function (cloneDoc) {
              let cloned = cloneDoc.getElementById("download-data");
              if (cloned) {
                cloned.style.display = 'block';
              }
            }
          }).then((canvas) => {
            canvas.toBlob((blob) => {
              if (blob) {
                let link = document.createElement("a");
                var filename = this.certificateData?.courseName + " (" + this.user?.username + ")" + ".pdf";
                link.href = URL.createObjectURL(blob);
                var img = new Image();
                img.src = link.href;
                let imgWidth: number = 0, imgHeight: number = 0;
                img.onload = () => {
                  //Modify width and height here to adjust the output image size
                  imgWidth = img.width
                  imgHeight = img.height;
                  this.printNewSizeImage(imgWidth, imgHeight, link.href, filename);
                }
              }
            });
          });
        }
        this.loadingCert = false;
      }, 1000)
    } catch (e) {
      console.log(e)
      this.loadingCert = false;
    }
  }

  printNewSizeImage(width: number, height: number, href: string, filename: string) {
    console.log(width, height)
    var newSizeImg = new Image()
    newSizeImg.src = href;
    newSizeImg.width = width
    newSizeImg.height = height

    // var width = pdf.internal.pageSize.getWidth();
    // var height = pdf.internal.pageSize.getHeight();
    // img.width = width;
    // img.height = height;

    newSizeImg.onload = function () {
      let pdf = new jsPDF({
        orientation: 'l',
        unit: 'px',
        format: [newSizeImg.width, newSizeImg.height],
      });

      pdf.addImage(newSizeImg, 0, 0, newSizeImg.width, newSizeImg.height);
      pdf.save(filename);
    }
  }

  formatDateNew(dateString?: string): Date | null {
    if (!dateString || typeof dateString !== 'string') {
      console.error('Invalid date string');
      return null;
    }
    console.log(dateString);
    const datePart = dateString.split(' ')[0];
    if (!datePart) {
      console.error('Invalid date string format');
      return null;
    }
    const [day, month, year] = datePart.split('-');
    if (!day || !month || !year) {
      console.error('Invalid date format');
      return null;
    }

    const d = Number(day);
    const m = Number(month);
    const y = Number(year);
    if (isNaN(d) || isNaN(m) || isNaN(y)) {
      console.error('Invalid numeric date components');
      return null;
    }

    return new Date(y, m - 1, d);
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
